import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import SeeBreakdownButton from '@/components/Billing/SeeBreakdownButton.vue';
// import { DATE_FORMAT_DISPLAY } from '@/components/Billing/billing-service.const';
import { PurchaseDetails } from '@/components/Billing/billing-types';
// import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
// @ts-ignore
import MultiplePlansCheckoutDetails from '@/components/dialogs/UpgradeMultiplePlansDialog/MultiplePlansCheckoutDetails.vue';
// @ts-ignore
import ReviewAndCheckoutActionBox from '@/components/dialogs/UpgradeMultiplePlansDialog/ReviewAndCheckoutActionBox.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeMultiplePlansReview',
  props: {
    planEndDate: null,
    totalDueToday: null,
    renewableAmount: null,
    isLoadingPurchase: { type: Boolean },
    newPurchaseDetails: null,
    currentPurchaseDetails: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	planEndDate: string;
	totalDueToday: string;
	renewableAmount: string;
	isLoadingPurchase: boolean;
	newPurchaseDetails: PurchaseDetails;
	currentPurchaseDetails: PurchaseDetails;
}

// import moment from 'moment';


const {
	// isSmartUpgradeEnabled,
	isAnnuallyPlan,
} = useBilling();
// const openSmartUpgradeDialog = () => {
// 	AppDialogManagerService.openSmartUpgradeDialog();
// };
// const renewReadableDate = computed(() => moment(props.planEndDate).format(DATE_FORMAT_DISPLAY));

const checkoutDetails = computed(() => [
	{
		title: 'Billing period',
		descriptionStyle: { 'font-weight': 400 },
		description: isAnnuallyPlan.value ? 'Annual' : 'Monthly',
	},
	{
		title: 'Total due today',
		description: props.totalDueToday,
		titleSuffixComponent: SeeBreakdownButton,
		titleSuffixProps: { newPurchaseDetails: props.newPurchaseDetails, currentPurchaseDetails: props.currentPurchaseDetails },
	},
	{
		title: `Renews ${isAnnuallyPlan.value ? 'annually' : 'monthly'} for`, // on ${renewReadableDate.value}
		description: props.renewableAmount,
	},
]);
const switchToAnnual = () => {
	isAnnuallyPlan.value = true;
	emit('close');
	// we are closing the dialog here because the selected plans have changed, and the quantity of the selected plans will be updated in the parent component.
	// after this toggle, newPurchaseDetails will not be updated properly, so we need to close the dialog and open it again to update the newPurchaseDetails.
};

return { __sfc: true,emit, props, isAnnuallyPlan, checkoutDetails, switchToAnnual, MultiplePlansCheckoutDetails, ReviewAndCheckoutActionBox }
}

})